export default {
  'Screenshot': "Capture d'écran",
}